<img *ngIf="mostrarImg" [src]="rutaImagen" height="35" width="35" alt="">&nbsp;<label for={{id}} [class]="claseLabel">{{label}}</label>
<ng-multiselect-dropdown [placeholder]="placeholder" [data]="comboBox"
  [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedItems" [settings]="dropdownSettings"
  (onSelect)="onItemSelect($event)" 
  (onSelectAll)="onSelectAll($event)" 
  (onDeSelect)="onItemDeSelect($event)"
  (onDeSelectAll)="onItemDeSelecAll($event)"
  
  ></ng-multiselect-dropdown>
<!-- [ngModelOptions]="{standalone: true}"
 
</ng-multiselect-dropdown> 
[ngModelOptions]="{standalone: true}" -->
